import { FormikErrors } from 'formik';

const isObject = (value: unknown) => {
  return value && typeof value === 'object' && value.constructor === Object;
};

const getKeysRecursively = (object: any): string => {
  if (!isObject(object)) {
    return '';
  }
  const currentKey = Object.keys(object)[0];
  if (!getKeysRecursively(object[currentKey])) {
    return currentKey;
  }
  return `${currentKey}.${getKeysRecursively(object[currentKey])}`;
};

export const scrollToErrors = (errors: FormikErrors<unknown>) => {
  const selectorKey = getKeysRecursively(errors);
  const selector = `[name="${selectorKey}"]`;

  if (selectorKey && selectorKey.length > 0) {
    const errorElement = document.querySelector<HTMLInputElement>(selector);
    if (errorElement) {
      errorElement.focus();
    }
  }
};
